import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import request from 'next/javascripts/modules/request';

import 'next/stylesheets/components/todo-page/desc';

Component('tr-todo-page-desc', {
  mixins: [eventListenerMixin],

  properties: {
    empty: {
      type: Boolean,
      default: true,
    },

    teamDraftPath: String,
  },

  connected() {
    this.listenTo(this, {
      click: this.handleClick.bind(this),
      'tr-todo-desc-form:submitted': this.handleDescFormSubmitted.bind(this),
      'tr-draft-confirmation:edit': () => {
        const draft = this.querySelector('tr-draft-confirmation');
        if (draft) draft.remove();
        const form = this.querySelector('tr-todo-desc-form');
        if (form) form.visible = true;
      },
      'tr-draft-confirmation:destroy': () => {
        const draft = this.querySelector('tr-draft-confirmation');
        if (draft) draft.remove();
      },
    });

    this.loadDraft();
  },

  handleDescFormSubmitted({ detail: desc }) {
    this.empty = !desc;

    const wrapper = this.querySelector('.desc-wrapper');
    const content = wrapper.querySelector('.desc-content').cloneNode();
    content.innerHTML = desc;

    const outputRenderer = document.createElement('tr-editor-output-renderer');
    outputRenderer.appendChild(content);

    wrapper.replaceChild(
      outputRenderer,
      wrapper.querySelector('tr-editor-output-renderer'),
    );
  },

  handleClick(event) {
    if (!closest(event.target, '.link-latest-version', this)) return;

    const wrapper = this.querySelector('#desc-version-wrapper');
    if (wrapper) wrapper.innerHTML = '';

    const originDesc = this.querySelector('.desc-content');
    if (originDesc) originDesc.style.display = 'block';
  },

  loadDraft() {
    if (!this.teamDraftPath) return;
    this.loadDraftXHR = request({
      url: this.teamDraftPath,
      method: 'get',
      dataType: 'script',
      complete: () => {
        this.loadDraftXHR = null;
      },
    });
  },

  disconnected() {
    if (this.loadDraftXHR) this.loadDraftXHR.abort();
    this.stopListening();
  },
});
